var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81469 52.7086C1.08408 51.7747 0 49.9722 0 48.0065V5.33551C0 3.3698 1.09061 1.56082 2.82122 0.63347C4.55184 -0.293877 6.65469 -0.189388 8.29388 0.901225L40.2939 22.2302C41.7763 23.2229 42.6645 24.8816 42.6645 26.6645C42.6645 28.4473 41.7763 30.1127 40.2873 31.0988L8.28735 52.4343C6.65469 53.5314 4.55184 53.6359 2.81469 52.7086ZM48 53.3355C45.0482 53.3355 42.6645 50.9518 42.6645 48V26.671V5.33551C42.6645 2.38367 45.0482 0 48 0H58.6645C61.6163 0 64 2.38367 64 5.33551V48C64 50.9518 61.6163 53.3355 58.6645 53.3355H48Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.7e84d051829ce28b9851886289cab488.svg";
export { ForwardRef as ReactComponent };